import { SkapaElement } from "@ingka/skapa-webc-element";
const styles = ':host{--skapa-inline-message-colour:rgb(var(--colour-semantic-informative,0,88,163));background-color:rgb(var(--colour-elevation-1,255,255,255));border:0 solid rgb(var(--colour-elevation-1-border,223,223,223))!important;border-inline-start:.25rem solid var(--skapa-inline-message-colour)!important;border-radius:4px;box-shadow:0 4px 16px #0000001a;box-sizing:border-box;display:flex;font-size:.875rem;min-height:1.5rem;overflow:hidden;padding:1rem 0;padding-inline-end:.5rem;position:relative;text-align:start}slot[name=message-icon]{color:var(--skapa-inline-message-colour);display:flex;flex-basis:3rem;flex-shrink:0;justify-content:center}slot[name=message-icon].skapa-empty{flex-basis:1rem}slot[name=close-button]{display:inline;margin-top:-.5rem;pointer-events:none}slot[name=close-button].skapa-empty{min-width:1.5rem}slot[name=close-button]::slotted(*){pointer-events:auto}#actions{display:flex;flex-wrap:wrap;justify-content:flex-end;margin-top:.5rem}#actions.skapa-empty{display:none}#actions::slotted(:not(:first-of-type)){margin-inline-start:.25rem}:host([subtle]){background:none;border:none!important;box-shadow:none;overflow:visible;padding:0}:host([subtle]) slot[name=message-icon]{flex-basis:2rem;justify-content:start}:host([subtle]) slot[name=message-icon].skapa-empty{display:none}:host([subtle]) slot[name=close-button]{margin-top:-.25rem;max-width:1.5rem;min-width:1.5rem}:host([subtle]) #actions{display:none}:host([subtle]) slot::slotted(skapa-button),:host([subtle]) slot[name=title]{display:none}:host([dismissed]){min-height:0;opacity:0;overflow:hidden;padding-bottom:0;padding-top:0;transition:all .2s cubic-bezier(.4,0,.4,1);visibility:hidden}:host([variant=cautionary]){--skapa-inline-message-colour:rgb(var(--colour-semantic-caution,242,106,47))}:host([variant=positive]){--skapa-inline-message-colour:rgb(var(--colour-semantic-positive,10,138,0))}:host([variant=negative]){--skapa-inline-message-colour:rgb(var(--colour-semantic-negative,224,7,81))}.content{flex-grow:1}slot[name=body]{color:rgb(var(--colour-text-and-icon-2,72,72,72));font-size:.875rem;line-height:1.571}slot[name=body]::slotted(*){font-size:inherit}slot[name=title]{color:rgb(var(--colour-text-and-icon-1,17,17,17));display:block;font-weight:700;line-height:1.571;margin:0;padding-bottom:.25rem}slot[name=title].skapa-empty{display:contents}slot[name=title]::slotted(*){font-size:inherit}@media (prefers-reduced-motion){:host([dismissed]){transition-duration:0ms}}@media (prefers-contrast:more){:host{border-block-end-width:1px;border-block-start-width:1px;border-inline-end-width:1px}}';
function generateTemplate({ html }) {
  const template = document.createElement("template");
  template.innerHTML = html`
    <style>
      ${styles}
    </style>
    <slot name="message-icon"></slot>
    <div class="content">
      <slot name="title"></slot>
      <slot name="body"></slot>
      <slot id="actions"></slot>
    </div>
    <slot name="close-button"></slot>
  `;
  return { main: template };
}
function evaluateSlot(event) {
  const slot = event.target;
  checkSlot(slot);
}
function checkSlot(slot) {
  slot.classList.toggle(
    "skapa-empty",
    !slot.assignedElements({ flatten: true }).length
  );
}
class InlineMessage extends SkapaElement {
  constructor() {
    super();
    this.handleClick = () => {
      if (!this.dismissed) this.dismissed = true;
    };
    this.gatherProperties(["subtle", "variant", "dismissed"], this);
    const shadow = this.shadow = this.attachShadow({ mode: "open" });
    const template = this.getTemplates(generateTemplate);
    shadow.append(template.main.content.cloneNode(true));
    this.closeButtonSlot = shadow.querySelector(
      "slot[name=close-button]"
    );
  }
  static get observedAttributes() {
    return ["dismissed"];
  }
  connectedCallback() {
    super.connectedCallback();
    Array.from(this.shadow.querySelectorAll("slot")).map(checkSlot);
    this.shadow.addEventListener("slotchange", evaluateSlot);
    this.setAttribute("aria-hidden", this.dismissed.toString());
    this.closeButtonSlot.addEventListener("click", this.handleClick);
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this.shadow.removeEventListener("slotchange", evaluateSlot);
    this.closeButtonSlot.removeEventListener("click", this.handleClick);
  }
  attributeChangedCallback(attributeName, oldValue, newValue) {
    if (newValue !== null) {
      this.style.height = `${this.clientHeight}px`;
      requestAnimationFrame(() => this.style.height = "0px");
    } else {
      this.style.removeProperty("height");
    }
    this.setAttribute("aria-hidden", (!(newValue === null)).toString());
  }
  get subtle() {
    return this.hasAttribute("subtle");
  }
  set subtle(value) {
    this.toggleAttribute("subtle", !!value);
  }
  get dismissed() {
    return this.hasAttribute("dismissed");
  }
  set dismissed(value) {
    this.toggleAttribute("dismissed", !!value);
  }
  get variant() {
    return this.getAttribute("variant") || "informative";
  }
  set variant(value) {
    if (!value) this.removeAttribute("variant");
    else this.setAttribute("variant", value);
  }
}
InlineMessage.skapaTagName = "inline-message";
InlineMessage.skapaDependencies = [];
var InlineMessage_default = InlineMessage;
export {
  InlineMessage,
  InlineMessage_default as default
};
